import { RepositoryBase } from '@app/repositories/RepositoryBase';

export class ShapeStandardRepository<
    ShapeStandardModel
> extends RepositoryBase<ShapeStandardModel> {
    public constructor() {
        super('shapeStandard');
    }
}
